module.exports = __webpack_public_path__ + "static/media/hero1.7fbf1358.jpg";